"use client";

import type { ToolCall } from "../../types";

import { ToolCallDisplay } from "./ToolCallDisplay";

interface ToolCallsSectionProps {
  toolCalls: ToolCall[];
  isStreaming?: boolean;
}

export const ToolCallsSection = ({
  toolCalls,
  isStreaming,
}: ToolCallsSectionProps) => (
  <>
    {toolCalls.map((call) => (
      <ToolCallDisplay
        key={call.id}
        name={call.function.name}
        rawArgs={call.function.arguments}
        isStreaming={isStreaming}
      />
    ))}
  </>
);
